<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-12">
      <h1>Privacy Policy</h1>
      <p>
        At Spacepack, accessible from
        <a href="https://spacepack.ph">https://spacepack.ph</a>&nbsp;and all of
        its subdomains, one of our main priorities is the privacy of our
        visitors. This Privacy Policy document contains types of information
        that is collected and recorded by Spacepack and how we use it.
      </p>
      <p>
        If you have additional questions or require more information about our
        Privacy Policy, do not hesitate to contact us.
      </p>
      <h3>General Data Protection Regulation (GDPR)</h3>
      <p>We are a Data Controller of your information.</p>
      <p>
        Spacepack Inc. legal basis for collecting and using the personal
        information described in this Privacy Policy depends on the Personal
        Information we collect and the specific context in which we collect the
        information:
      </p>
      <ul>
        <li>Spacepack Inc. needs to perform a contract with you</li>
        <li>You have given Spacepack Inc. permission to do so</li>
        <li>
          Processing your personal information is in Spacepack Inc. legitimate
          interests
        </li>
        <li>Spacepack Inc. needs to comply with the law</li>
      </ul>
      <p>
        Spacepack Inc. will retain your personal information only for as long as
        is necessary for the purposes set out in this Privacy Policy. We will
        retain and use your information to the extent necessary to comply with
        our legal obligations, resolve disputes, and enforce our policies. Our
        Privacy Policy was generated with the help of GDPR Privacy Policy
        Generator and the GDPR Privacy Policy Generator.
      </p>
      <p>
        If you are a resident of the European Economic Area (EEA), you have
        certain data protection rights. If you wish to be informed what Personal
        Information we hold about you and if you want it to be removed from our
        systems, please contact us.
      </p>
      <p>
        In certain circumstances, you have the following data protection rights:
      </p>
      <ul>
        <li>
          The right to access, update or to delete the information we have on
          you.
        </li>
        <li>The right of rectification.</li>
        <li>The right to object.</li>
        <li>The right of restriction.</li>
        <li>The right to data portability</li>
        <li>The right to withdraw consent</li>
      </ul>
      <h3>Log Files</h3>
      <p>
        Spacepack follows a standard procedure of using log files. These files
        log visitors when they visit websites. All hosting companies do this and
        a part of hosting services' analytics. The information collected by log
        files include internet protocol (IP) addresses, browser type, Internet
        Service Provider (ISP), date and time stamp, referring/exit pages, and
        possibly the number of clicks. These are not linked to any information
        that is personally identifiable. The purpose of the information is for
        analyzing trends, administering the site, tracking users' movement on
        the website, and gathering demographic information.
      </p>
      <h3>Cookies and Web Beacons</h3>
      <p>
        Like any other website, Spacepack uses 'cookies'. These cookies are used
        to store information including visitors' preferences, and the pages on
        the website that the visitor accessed or visited. The information is
        used to optimize the users' experience by customizing our web page
        content based on visitors' browser type and/or other information.
      </p>
      <p>
        For more general information on cookies, please read "What Are Cookies".
      </p>
      <h3>Privacy Policies</h3>
      <p>
        You may consult this list to find the Privacy Policy for each of the
        advertising partners of Spacepack.
      </p>
      <p>
        Third-party ad servers or ad networks use technologies like cookies,
        JavaScript, or Web Beacons that are used in their respective
        advertisements and links that appear on Spacepack, which are sent
        directly to users' browsers. They automatically receive your IP address
        when this occurs. These technologies are used to measure the
        effectiveness of their advertising campaigns and/or to personalize the
        advertising content that you see on websites that you visit.
      </p>
      <p>
        Note that Spacepack has no access to or control over these cookies that
        are used by third-party advertisers.
      </p>
      <h3>Third-Party&nbsp;Privacy Policies</h3>
      <p>
        Spacepack's Privacy Policy does not apply to other advertisers or
        websites. Thus, we are advising you to consult the respective Privacy
        Policies of these third-party ad servers for more detailed information.
        It may include their practices and instructions about how to opt-out of
        certain options.
      </p>
      <p>
        You can choose to disable cookies through your individual browser
        options. To know more detailed information about cookie management with
        specific web browsers, it can be found at the browsers' respective
        websites.
      </p>
      <h3>Children's Information</h3>
      <p>
        Another part of our priority is adding protection for children while
        using the internet. We encourage parents and guardians to observe,
        participate in, and/or monitor and guide their online activity.
      </p>
      <p>
        Spacepack does not knowingly collect any Personal Identifiable
        Information from children under the age of 13. If you think that your
        child provided this kind of information on our website, we strongly
        encourage you to contact us immediately and we will do our best efforts
        to promptly remove such information from our records.
      </p>
      <h3>Online Privacy Policy Only</h3>
      <p>
        Our Privacy Policy applies only to our online activities and is valid
        for visitors to our website with regards to the information that they
        shared and/or collected in Spacepack. This policy is not applicable to
        any information collected offline or via channels other than this
        website.
      </p>
      <h3>Consent</h3>
      <p>
        By using our website, you hereby consent to our Privacy Policy and agree
        to its terms.
      </p>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    open() {
      this.dialog = true
    }
  }
}
</script>

<style scoped>
h1 {
  margin-bottom: 20px;
}

h3 {
  margin-top: 10px;
  margin-bottom: 5px;
}

p {
  color: black;
  margin-bottom: 15px !important;
}

ol,
ul {
  margin-bottom: 15px;
}
</style>
